import styled from 'styled-components/macro';
import Typography from '@material-ui/core/Typography';

const Headline4 = styled(Typography).attrs({
  variant: 'h4',
  component: 'h4',
})`
  font-weight: bold;
  text-align: left;
  font-size: 14px
`;

export default Headline4;
